import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: ({startDate}, pagination, ordering, download = 0) => ({
        ...pagination,
        ordering,
        download,
        date: Math.floor(startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:                'CMDBServiceDetails',
        endpoint:            endpoints.cmdb.serviceDetails,
        timeout:             TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformEntitiesFn: item => ({
            managed:        item.managed,
            lastBackup:     item.last_backup ? item.last_backup * TIMESTAMP_MULTIPLY : undefined,
            className:      item.class_name,
            windowsPatch:   item.windows_patch,
            ciName:         item.ci_name,
            withMonitoring: item.with_monitoring,
            lastPatchDate:  item.patch_status === 'not_upgradable' ? 'N/A' : item.last_patch_date ? item.last_patch_date * TIMESTAMP_MULTIPLY : undefined,
            patchStatus:    item.patch_status,
            withBackup:     item.with_backup
        })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/CMDBServiceDetails.js